import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Box } from '@mui/system';
import { Divider, IconButton, Tooltip, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';
import SyncIcon from '@mui/icons-material/Sync';

import HydrotestLogo from '../../assets/logo-hydrotest.png';
import TecneaInspection from '../../assets/logo-technea-inspection.png';
import AccountIcon from '../../assets/icone-connexion.png';
import { DB, Constant } from "../../constants";
import { SideMenuDrawer, CustomizedConfirmDialog, ModalChangeUserPasswordInput, CustomizedDialog, GlobeIcon } from '../../components';
import { DetectNetwork, TranslateStringValue } from '../../utilities';
import "./style.css";
import { useTranslation } from 'react-i18next';
import i18next from "i18next";

const NavigationBar = (props) => {
    const {
        handleSyncButtonClick,
        showToolBar,
        showNavBar
    } = props
    const navigate = useNavigate();
    const { online } = DetectNetwork();
    const { t: translate } = useTranslation();

    const [authorize, setAuthorize] = useState(false);
    const menuList = [translate('enterReportTitle'), translate('pendingReports'), translate('synchronizedReports')];

    const currentLogInUserId = localStorage.getItem(Constant.localStorageKey.userId);
    const [userList, setUserList] = useState([]);

    const [openDialog, setOpenDialog] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogBtnLabel, setDialogBtnLabel] = useState("")
    const [dialogBody, setDialogBody] = useState(<p></p>)

    const languagesList = [
        ['FR-FR', 'fr-FR'],
        ['EN-GB', 'en-GB']
    ]

    const [ selectedLanguageIndex, setSelectedLanguageIndex ] = useState(0);

    const getListUser = async () => {
        const userQuery = await DB.users.toArray();
        const userLists = userQuery.map(user => [(user.data.personnel_controleur.nom), user.data.personnel_controleur.id]);
        //Sort list of user by current login user
        const currentUserInfo = userQuery.filter((user) => user.data.personnel_controleur.id === currentLogInUserId);
        const currentUser = currentUserInfo[0].data.personnel_controleur.nom;
        const findUserIndex = userLists.findIndex(userIndex => userIndex[0] === currentUser);
        userLists.splice(findUserIndex, 1);
        userLists.unshift([currentUser, currentLogInUserId]);
        setUserList(userLists);
    }

    const [syncing, setSyncing] = useState(false);
    const isLoggedIn = localStorage.getItem(Constant.localStorageKey.isLoggedIn);
    const [modalBody, setModalBody] = useState();
    const [openModalInput, setOpenModalInput] = useState();
    const [userToBeChange, setUserToBeChange] = useState();
    const [userIdToBeChange, setUserIdToBeChange] = useState();

    const handleChangeUser = (user, userId) => {
        if (currentLogInUserId !== userId){
            setOpenModalInput(true);
            setUserToBeChange(user);
            setUserIdToBeChange(userId);
        }
    }

    const handleClickMenu = (menu) => {
        switch (menu) {
            case translate('enterReportTitle'):
                navigate("/", { state: { prev: true } })
                break;
            case translate('pendingReports'):
                navigate("/savedForm", { state: { prev: true } })
                break;
            case translate('synchronizedReports'):
                navigate("/history", { state: { prev: true } })
                break;
            default:
                break;
        }
    }
    // sync all data from ws_getform & ws_getmaterials
    const handleSynchronizeDatas = async () => {
        if (online) {
            setSyncing(true);
            await handleSyncButtonClick()
            setSyncing(false)
        }
    }

    const handleLogOut = () => {
        setAuthorize(!authorize);
        localStorage.setItem(Constant.localStorageKey.isLoggedIn, false);
        localStorage.removeItem(Constant.localStorageKey.userId);
        window.location.replace(process.env.PUBLIC_URL + "/login")
    }

    //Dropdown language options
    const [langAnchorEl, setLangAnchorEl] = useState(null);
    const showLanguageOption = Boolean(langAnchorEl);
    //Dropdown user account
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClickLanguageSwitcher = (event) => {
        setLangAnchorEl(event.currentTarget)
    }
    const handleClickProfile = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setLangAnchorEl(null);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }

    const handleSwitchLanguage = async (languageAbbreviation, index) => {
        const translationConfigDataQuery = await DB.translationConfigData.toArray();
        const currentLanguageConfig = translationConfigDataQuery.filter((config) => config.language === languageAbbreviation);
        const translationConfig = currentLanguageConfig[0].config;
        if (!translationConfig.datahydrotest) {
            setDialogTitle(translate('alert'));
            setOpenDialog(true)
            setDialogBody(<>
                <p>{translate('languageNotAvailable')}</p>
            </>)
            setDialogBtnLabel(translate('ok'))
        }
        else if (translationConfig.datahydrotest) {
            i18next.changeLanguage(languageAbbreviation);
        }

        setSelectedLanguageIndex(index);
    }

    //Modal
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        setOpenModal(true);
        setModalBody(
            <Typography>{translate('logOutAlert')}</Typography>
        )
    }

    useEffect(() => {
        const isLoggedInTemp = localStorage.getItem(Constant.localStorageKey.isLoggedIn);
        if (isLoggedInTemp === 'true') {
            getListUser();
            setAuthorize(true);
        } else {
            setAuthorize(false);
        }
    }, [authorize])

    return (
        <Box className="app-bar">
            <div className='header-bar'>
                <img alt='' className='header-hydro-logo' src={HydrotestLogo} />
                <img alt='' className='header-tecnea-logo' src={TecneaInspection} />
            </div>
            {authorize && !syncing && showNavBar ? <div className='lower-bar-container'>
                <div className="lower-bar">
                    <div className='menu-icon'>
                        <SideMenuDrawer />
                    </div>
                    <ul>
                        <li>
                            {menuList.map(menu => {
                                return <button key={menu} className='lower-bar-list' onClick={() => handleClickMenu(menu)}>
                                    <p>{menu}</p>
                                </button>
                            })}
                        </li>
                    </ul>
                    {/* Internet indicator */}
                    {TranslateStringValue.translate(isLoggedIn) && showToolBar ?
                        <div>
                            <div>
                                <Tooltip style={{ display: online ? true : 'none' }} title="You're online">
                                    <WifiOutlinedIcon sx={{ color: 'green' }} />
                                </Tooltip>
                                <Tooltip style={{ display: online ? 'none' : true, marginRight: online ? 0 : 5, marginBottom: online ? 0 : 2 }} title="you're offline">
                                    <WifiOffOutlinedIcon sx={{ color: 'red' }} />
                                </Tooltip>
                                <button style={{ display: online ? true : 'none' }} className='sync-button' onClick={handleSynchronizeDatas}>
                                    <Tooltip title="Synchronize Data">
                                        <IconButton>
                                            <SyncIcon style={{ color: 'black', rotate: '90deg' }} />
                                        </IconButton>
                                    </Tooltip>
                                </button>
                                <button
                                    style={{ marginBottom: online ? 0 : 4}}
                                    className='language-switcher'
                                    onClick={handleClickLanguageSwitcher}
                                    size="small"
                                    aria-controls={open ? 'account-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                >
                                    <GlobeIcon />
                                </button>
                                <Menu
                                    anchorEl={langAnchorEl}
                                    id="account-menu"
                                    open={showLanguageOption}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    PaperProps={{
                                        elevation: 0,
                                        sx: {
                                            boxShadow: 3,
                                            overflow: 'visible',
                                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                            mt: 1.5,
                                            '&:before': {
                                                content: '""',
                                                display: 'block',
                                                position: 'absolute',
                                                top: 0,
                                                right: 14,
                                                width: 10,
                                                height: 10,
                                                bgcolor: 'background.paper',
                                                transform: 'translateY(-50%) rotate(45deg)',
                                                zIndex: 0,
                                            },
                                        },
                                    }}
                                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                >
                                    {languagesList.map(([language, languageAbbreviation], index) => {
                                        return  <>
                                                    <MenuItem key={index} onClick={() => handleSwitchLanguage(languageAbbreviation, index)} style={{fontWeight: selectedLanguageIndex === index ? 'bold' : 'inherit' ,marginTop: '-5px', marginBottom: '-5px', height: '50px', width: '100px'}}>
                                                        {language}
                                                    </MenuItem>
                                                    {index === 0 ? <Divider /> : null}
                                                </>
                                    })}
                                </Menu>
                            </div>
                        </div>
                        :
                        (
                            online ?
                                <Tooltip className='online-status' title="You're online">
                                    <WifiOutlinedIcon sx={{ color: 'green' }} />
                                </Tooltip>
                                :
                                <Tooltip className='offline-status' title="you're offline">
                                    <WifiOffOutlinedIcon title="You're offline" sx={{ color: 'red' }} />
                                </Tooltip>
                        )

                    }
                </div>
                {showToolBar ? !authorize ? (
                    <button className='account-button' href='/login' type='submit' variant='contained' color='warning'>connexion</button>
                ) :
                    <React.Fragment>
                        <button
                            className='account-button'
                            onClick={handleClickProfile}
                            size="small"
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <img alt='' src={AccountIcon} />
                            <span>{translate('user')}</span>
                        </button>
                        <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    boxShadow: 3,
                                    overflow: 'visible',
                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                    mt: 1.5,
                                    '&:before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                    },
                                },
                            }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            {userList.map(([userName, id], index) => {
                                return  <MenuItem key={id} onClick={() => handleChangeUser(userName, id)} sx={{fontWeight: id === currentLogInUserId ? 'bold' : null}}>
                                            <ListItemIcon>
                                                <AccountCircleIcon fontSize="small" sx={{color: id === currentLogInUserId ? 'black' : null}}/>
                                            </ListItemIcon>
                                            {userName}
                                        </MenuItem>
                            })}
                            <Divider />
                            <MenuItem onClick={handleOpenModal}>
                                <ListItemIcon>
                                    <Logout fontSize="small" />
                                </ListItemIcon>
                                {translate('logout')}
                            </MenuItem>
                        </Menu>
                    </React.Fragment>
                    : null
                }
            </div> : null}
            <ModalChangeUserPasswordInput
                userToBeChange = {userToBeChange}
                userIdToBeChange = {userIdToBeChange}
                open = {openModalInput}
                title = {translate('enterPassword')}
                onCancel = {() => {
                    setOpenModalInput(false);
                }}
            >

            </ModalChangeUserPasswordInput>
            <CustomizedConfirmDialog
                open={openModal}
                title="Avertissement"
                confirmBtnLabel="Ok"
                cancelBtnLabel={translate('cancel')}
                onCancel={() => {
                    setOpenModal(false);
                }}
                onConfirm={() => {
                    setOpenModal(false);
                    handleLogOut();
                }}

            >
                {modalBody}
            </CustomizedConfirmDialog>
            <CustomizedDialog
                open={openDialog}
                title={dialogTitle}
                showActionButton={true}
                closeBtnLabel={dialogBtnLabel}
                onClose={handleCloseDialog}
            >
                {dialogBody}
            </CustomizedDialog>
        </Box>
    );
}
export default NavigationBar;